import { render } from "./ChangePass.vue?vue&type=template&id=e3d506a6&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=ts"
export * from "./ChangePass.vue?vue&type=script&lang=ts"

import "./ChangePass.vue?vue&type=style&index=0&id=e3d506a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e3d506a6"

export default script